import { Route, Routes } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  OfflineCoreServices,
  CallCoreServicesActionWithToken,
} from "../../../appRedux/actions/CoreServicesAction";
import { useEffect } from "react";
import Url from "../../../apiCall/UrlConfig";
import { message } from "antd";
import PeriapicallesionMainPage from "./periapicallesionMainPage";
import AnalysisPeriapicalLesion from "./AnalysisPeriapicalLesion";
// import OpgNumberingMainPage from "./OpgNumberingMainPage";
// import AnalysisOpgNumberign from "./AnalysesOpgNumbering";
// import ListImageSegmation from "./ListImageSegmation";

// // import AnalysesNumberTeeth from "./AnalysesNumberTeeth";
// import ListAnalysesOpgNumbering from "./ListAnalysisOpgNumering";
// import OpgSegmentAnalysis from "./OpgSegmentAnalysis";

const RouterPeriapicalLesion = (props) => {
  useEffect(() => {
    _getUserInfo();
  }, []);

  const _getUserInfo = async () => {
    let url = Url.getuserInfoperispicallesion;

    let res = await props.actions.CallCoreServicesActionWithToken(url, {});

    console.log(res);
    if (res.hasError) {
      message.error(res.message);
      return;
    }
  };

  let userObj =
    props.coreData[Url.getuserInfoperispicallesion]?.[Url.action]?.data;

  return (
    <div>
      {userObj?.examPassed && (
        <>
          <Routes>
            <Route
              path="/mainpage/analyses/:id"
              element={<AnalysisPeriapicalLesion />}
            />
            <Route
              path="/mainpage/analyses/:id/:idAnalyses"
              element={<AnalysisPeriapicalLesion />}
            />
            {/* <Route path="/mainpage/segment" element={<ListImageSegmation />} /> */}
            {/* <Route
              path="/mainpage/segment/analyses/:id"
              element={<OpgSegmentAnalysis />}
            /> */}
            <Route path="/mainpage" element={<PeriapicallesionMainPage />} />
            {/* <Route
              path="/mainpage/youranalyses"
              element={<ListAnalysesOpgNumbering />}
            /> */}
          </Routes>
        </>
      )}
      {userObj?.examPassed === false && (
        <>
          <div>You Dont Have Enough Permission</div>
        </>
      )}
    </div>
  );
};

const actionCreators = Object.assign(
  {},
  { CallCoreServicesActionWithToken, OfflineCoreServices }
);
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
});

const mapStateToProps = (state) => ({
  coreData: state.coreservices.coreData,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RouterPeriapicalLesion);
